import {GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter} from "@mui/x-data-grid";
import React from "react";

const CustomToolbar = () => {
	return (
		<GridToolbarContainer sx={{display: 'flex', justifyContent: 'space-between'}}>
			<GridToolbarFilterButton/>
			<GridToolbarQuickFilter/>
		</GridToolbarContainer>
	);
}

export default CustomToolbar;
